/* eslint-disable no-case-declarations */
import { useCallback, useEffect, useState } from 'react';
import { Circle, Document, G, Image, Page, Path, Svg, Text, View, Link } from '@react-pdf/renderer';
import { PropTypes } from 'prop-types';
import domtoimage from 'dom-to-image';
import Html from 'react-pdf-html';

import useLocales from '../../../hooks/useLocales';
import ArticlePrintStyle from './ArticlePrintStyle';
import ArticlePrintCO from './ArticlePrintCO';
import ArticlePrintLinks from './ArticlePrintLinks';

ArticlePrintDetail.propTypes = {
  article: PropTypes.object,
  // related: PropTypes.any,
  hideHeading: PropTypes.bool,
};

export default function ArticlePrintDetail({ article /* , related */, hideHeading }) {
  const { currentLang, translate } = useLocales();
  const styles = ArticlePrintStyle;
  const [mapImage, setMapImage] = useState(undefined);

  const loadMap = useCallback(async () => {
    // najdem mapu v elementoch
    const collection = document.getElementsByClassName('map');
    // ak som nasiel, tak z nej spravim obrazok
    if (collection.length > 0) {
      const map = collection[0];
      const mapProps = map.getBoundingClientRect();
      const data = await domtoimage.toPng(map, { width: mapProps.width, height: mapProps.height });
      setMapImage(data);
    }
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      loadMap();
    }, 2500); // musi sa nacitat mapa
    return () => {
      clearTimeout(timer);
    };
  }, [loadMap, article]);

  const calendarIcon = (
    <Svg viewBox="0 0 32 32" width="16px" height="16px" style={{ margin: 'auto' }}>
      <G fill="#000">
        <Path d="M20.5 19.2a.7.7 0 0 1 .7-.7h2.6a.7.7 0 0 1 .7.7v2.6a.7.7 0 0 1-.7.7h-2.6a.7.7 0 0 1-.7-.7v-2.6Zm-13-5a.7.7 0 0 1 .7-.7h2.6a.7.7 0 0 1 .7.7v2.6a.7.7 0 0 1-.7.7H8.2a.7.7 0 0 1-.7-.7v-2.6Zm1 .3v2h2v-2h-2Zm5.5-.3a.7.7 0 0 1 .7-.7h2.6a.7.7 0 0 1 .7.7v2.6a.7.7 0 0 1-.7.7h-2.6a.7.7 0 0 1-.7-.7v-2.6Zm1 .3v2h2v-2h-2Zm5.5-.3a.7.7 0 0 1 .7-.7h2.6a.7.7 0 0 1 .7.7v2.6a.7.7 0 0 1-.7.7h-2.6a.7.7 0 0 1-.7-.7v-2.6Zm1 .3v2h2v-2h-2Zm-14 4.7a.7.7 0 0 1 .7-.7h2.6a.7.7 0 0 1 .7.7v2.6a.7.7 0 0 1-.7.7H8.2a.7.7 0 0 1-.7-.7v-2.6Zm1 .3v2h2v-2h-2Zm5.5-.3a.7.7 0 0 1 .7-.7h2.6a.7.7 0 0 1 .7.7v2.6a.7.7 0 0 1-.7.7h-2.6a.7.7 0 0 1-.7-.7v-2.6Zm1 .3v2h2v-2h-2Zm-7.5 4.7a.7.7 0 0 1 .7-.7h2.6a.7.7 0 0 1 .7.7v2.6a.7.7 0 0 1-.7.7H8.2a.7.7 0 0 1-.7-.7v-2.6Zm1 .3v2h2v-2h-2Zm5.5-.3a.7.7 0 0 1 .7-.7h2.6a.7.7 0 0 1 .7.7v2.6a.7.7 0 0 1-.7.7h-2.6a.7.7 0 0 1-.7-.7v-2.6Zm1 .3v2h2v-2h-2Z" />
        <Path d="M15.011 5a3.271 3.271 0 0 0 2.384 3.421c.46.128.855-.27.855-.747c0-.351-.292-.626-.62-.753A1.77 1.77 0 0 1 16.52 5h3.491a3.271 3.271 0 0 0 2.384 3.421c.46.128.855-.27.855-.747c0-.351-.292-.626-.62-.753A1.77 1.77 0 0 1 21.52 5h5.721C29.311 5 31 6.691 31 8.785V26.24c0 2.62-2.125 4.76-4.759 4.76H5.76A4.768 4.768 0 0 1 1 26.24V8.785C1 6.691 2.69 4.99 4.759 5h.252a3.27 3.27 0 0 1 5.759-1.838A3.263 3.263 0 0 1 13.27 2c1.003 0 1.9.451 2.5 1.162A3.263 3.263 0 0 1 18.27 2c1.003 0 1.9.451 2.5 1.162A3.27 3.27 0 0 1 26.529 5h-1.51a1.77 1.77 0 0 0-3.493-.034l.003.034h-1.518l.003-.034a1.77 1.77 0 0 0-3.488 0l.003.034h-1.518Zm-3.49 0h-1.51a3.271 3.271 0 0 0 2.384 3.421c.46.128.855-.27.855-.747c0-.351-.292-.626-.62-.753A1.77 1.77 0 0 1 11.52 5h3.491l.003-.034a1.77 1.77 0 0 0-3.488 0l.003.034h-.009Zm-6.515.073a3.271 3.271 0 0 0 2.389 3.348c.46.128.855-.27.855-.747c0-.351-.292-.626-.62-.753A1.77 1.77 0 0 1 6.52 5h3.491l.003-.034A1.77 1.77 0 0 0 6.52 5h-.76a3.7 3.7 0 0 0-.753.073ZM3 26.24A2.768 2.768 0 0 0 5.759 29H22.51v-1.5H21.2a.7.7 0 0 1-.7-.7v-2.6a.7.7 0 0 1 .7-.7h2.6a.7.7 0 0 1 .2.029a4.24 4.24 0 0 1 2.77-1.029H29V11H3v15.24Zm20.51.52v2.033l5.293-5.293H26.77a3.27 3.27 0 0 0-3.26 3.26ZM21.5 24.5v2h1.018v-.013l.004-.046a4.23 4.23 0 0 1 .64-1.941H21.5Z" />
      </G>
    </Svg>
  );

  const userIcon = (
    <Svg viewBox="0 0 16 16" width="16px" height="16px" style={{ margin: 'auto' }}>
      <G fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5">
        <Circle cx="8" cy="6" r="3.25" />
        <Path d="M2.75 14.25c0-2.5 2-5 5.25-5s5.25 2.5 5.25 5" />
      </G>
    </Svg>
  );

  const hourIcon = (
    <Svg viewBox="0 0 1024 1024" width="16px" height="16px" style={{ margin: 'auto' }}>
      <Path
        fill="currentColor"
        d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448s448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372s372 166.6 372 372s-166.6 372-372 372z"
      />
      <Path
        fill="currentColor"
        d="M686.7 638.6L544.1 535.5V288c0-4.4-3.6-8-8-8H488c-4.4 0-8 3.6-8 8v275.4c0 2.6 1.2 5 3.3 6.5l165.4 120.6c3.6 2.6 8.6 1.8 11.2-1.7l28.6-39c2.6-3.7 1.8-8.7-1.8-11.2z"
      />
    </Svg>
  );

  // const getVideoCode = (url) => {
  //   let idx = url.indexOf('v=');
  //   if (idx === -1) {
  //     idx = url.indexOf('embed/');
  //     if (idx >= 0) {
  //       idx += 6; // skocim o "embed/";
  //     }
  //   } else {
  //     idx += 2; // skocim o "v="
  //   }
  //   const code = url.substring(idx, url.length);
  //   return code;
  // };

  const decodeRichText = (text) => {
    if (text) {
      // hlavne sa tohoto nechytat - je to preto, ze html zle parsuje <li>
      let out = text.replaceAll('<li', '\n<div');
      out = out.replaceAll('</li>', '</div>');
      out = out.replaceAll('<ol>', '');
      out = out.replaceAll('</ol>', '');
      out = out.replaceAll('<ul>', '');
      out = out.replaceAll('</ul>', '');
      out = out.replaceAll('windowtext', 'blue');
      // lebo nefunguje Lato font
      out = out.replaceAll('blockquote', 'div');
      out = out.replaceAll('<em', '<div');
      out = out.replaceAll('</em>', '</div>');

      const firstIdx = out.indexOf('\n');
      if (firstIdx === 0) {
        out = out.substring(1); // ak je na zaciatku novy riadok tak ho preskoc - lebo preco nie
      }
      const stylesheet = {
        p: {
          fontSize: '12px',
          fontFamily: 'Lato',
        },
        blockquote: {
          fontSize: '12px',
        },
        em: {
          fontSize: '12px',
        },
        div: {
          fontSize: '12px',
          fontFamily: 'Lato',
        },
        ol: {
          fontSize: '12px',
          textAlign: 'left',
          fontFamily: 'Lato',
        },
        ul: {
          fontSize: '12px',
          textAlign: 'left',
          fontFamily: 'Lato',
        },
        li: {
          textAlign: 'left',
          fontFamily: 'Lato',
        },
      };
      return (
        <Html
          collapse={false} // za "strong" chybali medzery!
          stylesheet={stylesheet}
          style={{ fontFamily: 'Lato' }}
        >{`<div>${out}</div>`}</Html>
      );
    }
    return '';
  };

  const drawComponent = (component) => {
    switch (component.type) {
      case 0: // text / iframe
        return <Text>{decodeRichText(component?.content?.htmlContent)}</Text>; // TODO upraviť a nahradiť <div> atd
      // case 1: // text / iframe
      //   return <Text>{decodeRichText(component?.content?.text)}</Text>; // TODO upraviť a nahradiť <div> atd
      case 2: // obrazok
        return (
          <View>
            <Image
              src={`${process.env.REACT_APP_API_URL}/image/download/${component?.content?.imageKey}?sizeIndex=0`}
              style={styles.simpleImage}
            />
            <Text style={{ textAlign: 'center', fontFamily: 'Lato', marginTop: '8px' }}>
              {component?.content?.description}
            </Text>
          </View>
        );
      case 3: // galeria
        const images = component?.content?.images || [];
        const imagesPerView = 3; // Number of images per view
        const totalViews = Math.ceil(images.length / imagesPerView); // Total number of views

        const renderImageViews = () => {
          const imageViews = [];

          // eslint-disable-next-line no-plusplus
          for (let viewIndex = 0; viewIndex < totalViews; viewIndex++) {
            const startIndex = viewIndex * imagesPerView;
            const endIndex = startIndex + imagesPerView;
            const viewImages = images.slice(startIndex, endIndex);

            const imageView = (
              <View key={viewIndex} style={{ height: `159px` }}>
                {viewImages.map((item, idx) => (
                  <Image
                    key={item.imageKey + idx}
                    src={
                      item.imageKey !== undefined
                        ? `${process.env.REACT_APP_API_URL}/image/download/${item.imageKey}?sizeIndex=0`
                        : ''
                    }
                    style={{
                      ...styles.imageList,
                      left: `${(idx % 3) * 191}px`,
                      top: `${Math.floor(idx / 3) * 151 + 8}px`,
                    }}
                  />
                ))}
              </View>
            );

            imageViews.push(imageView);
          }

          return imageViews;
        };

        return (
          <View>
            <Text style={{ fontWeight: '500', fontFamily: 'Lato', marginTop: '8px' }}>
              {component?.content?.description}
            </Text>
            {renderImageViews()}
            <View style={{ height: `120px` }}>''</View>
          </View>
        );
      // 4 asi neexistuje
      case 5: // video
        return (
          <View>
            <Text style={{ fontSize: 16, fontWeight: 'bold', fontFamily: 'Lato' }}>
              {translate('articles.videoTitle')}
            </Text>
            <Link
              src={component?.content?.videoUrl}
              key={component?.content?.videoUrl}
              style={{ ...styles.listItem, marginTop: '8px', marginBottom: '8px' }}
            >
              {component?.content?.videoUrl}
            </Link>

            <Text style={{ fontFamily: 'Lato' }}>{component?.content?.description} </Text>
          </View>
        ); // CORS na localhoste pre video
      case 7: // heading
        return (
          <Text style={{ fontSize: 12 + (6 - component?.content?.type) * 4, fontWeight: 'bold', fontFamily: 'Lato' }}>
            {component?.content?.text}
          </Text>
        );
      case 8: // list
        return (
          <View>
            {component?.content?.list?.map((item, idx) => (
              <Text key={item.value + idx} style={styles.listItem}>
                &#x2022;&emsp;{item.value}
              </Text>
            ))}
          </View>
        );
      // 9, 10 asi neexistuje
      case 11: // quiz
        return (
          <View>
            <Text style={{ fontSize: '20px', fontWeight: 'bold', fontFamily: 'Lato' }}>
              {translate('articles.quizTitle')}
            </Text>
            {component?.content?.questions?.map((item, idx) => (
              <View key={idx}>
                <Text style={{ fontWeight: '500', marginTop: '16px', fontFamily: 'Lato' }}>{item.question}</Text>
                <View>
                  {item?.answers?.map((ans, aidx) => (
                    <Text key={ans.text + aidx} style={{ ...styles.listItem, marginLeft: '8px', fontFamily: 'Lato' }}>
                      &#x25A1;&emsp;{ans.text}
                    </Text>
                  ))}
                </View>
              </View>
            ))}
          </View>
        );
      case 12: // kulturny objekt
        return <ArticlePrintCO coKey={component?.content?.culturalObjectKey} />;
      default: // keby nahodou
        return '';
    }
  };

  return (
    article && (
      <Document
        title={article.title}
        author={article.author}
        subject={
          article.categories && article.categories.length > 0
            ? article.categories?.filter((f) => f.parentKey === '501')?.[0]?.name
            : article.title
        }
        keywords={article.seoKeywords}
        creator="BRAIN:IT"
        producer="BRAIN:IT"
        language={currentLang.label}
      >
        <Page size="A4" style={styles.page}>
          <View>
            <Image
              src={
                article.thumbnail !== undefined && article.thumbnail !== ''
                  ? `${process.env.REACT_APP_API_URL}/image/download/${article.thumbnail}?sizeIndex=0`
                  : ''
              }
            />
            <Text style={styles.titleShadow}>{article.title}</Text>
            <Text style={styles.subtitleShadow}>
              {article.categories?.filter((f) => f.parentKey === '501')?.[0]?.name || ''}
            </Text>
            <Text style={styles.title}>{article.title}</Text>
            <Text style={styles.subtitle}>
              {article.categories?.filter((f) => f.parentKey === '501')?.[0]?.name || ''}
            </Text>
          </View>
          <View style={styles.textContent}>
            {!hideHeading && (
              <View style={styles.heading}>
                <View style={{ ...styles.headingItem, left: '0%' }}>
                  {calendarIcon}
                  <Text style={styles.headingText}>{new Date(article.created).toLocaleDateString()}</Text>
                </View>
                <View style={{ ...styles.headingItem, left: '33.33333%' }}>
                  {userIcon}
                  <Text style={styles.headingText}>{article.author}</Text>
                </View>
                <View style={{ ...styles.headingItem, left: '66.66667%' }}>
                  {hourIcon}
                  <Text style={styles.headingText}>{article.estimatedReadTimeMinutes}</Text>
                </View>
              </View>
            )}
            {/* components */}
            <View>
              <Text style={styles.perex}>{article.perex}</Text>
            </View>
            <View style={{ marginBottom: '16px' }}>
              <Text style={{ fontFamily: 'Lato' }}>{article.subtext}</Text>
            </View>
            {article.components?.map((component, idx) => (
              <View key={idx} style={component?.type === 7 ? undefined : styles.component}>
                {drawComponent(component)}
              </View>
            ))}
            {mapImage && (
              <View style={{ marginTop: '16px' }}>
                <Image src={mapImage} />
              </View>
            )}
            {article?.links?.length > 0 && (
              <View style={{ marginTop: '16px' }}>
                <Text style={{ fontWeight: 'bold', fontSize: '20px', fontFamily: 'Lato' }}>
                  {translate('articles.related')}
                </Text>
                <ArticlePrintLinks links={article?.links} />
              </View>
            )}
            {/* {related?.length > 0 && (
              <View style={{ marginTop: '16px' }}>
                <Text style={{ fontWeight: 'bold', fontSize: '20px', fontFamily: 'Lato' }}>Objekty len ak su</Text>
              </View>
            )} */}
          </View>
        </Page>
      </Document>
    )
  );
}
